import { Route } from "@angular/router";
import { RenderEngineComponent } from "@app/pages/render-engine/render-engine.component";

export const NPS_ROUTES: Route[] = [
  {
    path: 'get_npsform',
    component: RenderEngineComponent,
  }
];